// extracted by mini-css-extract-plugin
export default {"rating":"HD-z","numberOfStars":"ID-z","count":"JD-z","barGraphSpacing":"KD-z","barGraph":"LD-z"};